module.exports = __webpack_public_path__ + "img/Co-working.55049959.png";